import React, { useEffect, useState } from 'react';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import WaitlistService from '../services/WaitlistService';

const formatTime = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const WaitlistPage = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await WaitlistService.list();
        if (!cancelled) {
          setEntries(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        if (!cancelled) {
          setError('Impossible de charger les pré-inscriptions');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="animate-in">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Pré-inscriptions</h1>
        <p className="text-surface-400">
          Créateurs inscrits sur la landing avant l’ouverture. Aucun compte n’a été créé.
        </p>
      </div>
      <div className="card overflow-hidden">
        <div className="px-6 py-4 border-b border-surface-800 flex items-center gap-2">
          <HowToRegIcon className="w-5 h-5 text-surface-400" />
          <h2 className="text-lg font-semibold text-white">Liste</h2>
        </div>
        {loading && <p className="p-6 text-surface-400">Chargement…</p>}
        {error && <p className="p-6 text-red-400">{error}</p>}
        {!loading && !error && entries.length === 0 && (
          <p className="p-6 text-surface-500">Aucune pré-inscription.</p>
        )}
        {!loading && !error && entries.length > 0 && (
          <ul className="divide-y divide-surface-800">
            {entries.map((entry) => (
              <li key={entry.id} className="px-6 py-4">
                <p className="text-sm font-medium text-white">
                  {entry.firstName} · {entry.craft}
                </p>
                <p className="text-xs text-surface-400">{entry.email}</p>
                <time className="block text-xs text-surface-500" dateTime={entry.createdAt}>
                  {formatTime(entry.createdAt)}
                </time>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default WaitlistPage;
